<template>
    <div class="footer-container">
        <div class="footer">
            <span v-if="hasError" class="error">
                <span v-if="!containsSupportedCharacter" data-qa="sms-template-unsupported-character-error">
                    Your message <strong>can only contain letters and numbers</strong>. Your message currently has unsupported characters (i.e., emojis, special characters, hidden characters, images, GIFs, etc.). This may be the result of copy-pasting. If the problem persists, try re-typing your message manually.
                </span>

                <span v-else path="characterCountError" data-qa="sms-template-character-count-error">
                    {{ $tc('sms.broadcast.secondaryFooter.error.tooLongError', maxLength, { count: maxLength }) }}
                </span>
            </span>

            <span class="character-count">
                {{ characterCountLabel }}
            </span>
        </div>
        <section class="template-button-row">
            <div class="action-buttons">
                <MergeFieldDropdown
                    v-click-outside="() => isMergeFieldDropdownOpen = false"
                    :is-open="isMergeFieldDropdownOpen"
                    position="bottom-start"
                    :merge-field-categories="mergeFieldCategories"
                    @select="({ value }) => insertMergeField(value)"
                >
                    <template #action>
                        <DsIconButton
                            name="merge-field"
                            @click="isMergeFieldDropdownOpen = !isMergeFieldDropdownOpen"
                        />
                    </template>
                </MergeFieldDropdown>
            </div>

            <div v-if="saving" class="saving semibold">
                <DsIcon name="loader" />

                <span>Saving</span>
            </div>

            <div v-if="saved" class="saved">
                <DsStatus type="good" emphasis="medium">
                    Saved
                </DsStatus>
            </div>

            <DsFilledButton class="insert-template" @click="insertTemplate">
                Insert template
            </DsFilledButton>

            <DsFilledButton class="insert-template-mobile" @click="insertTemplate">
                Insert
            </DsFilledButton>
        </section>
    </div>
</template>
<script>
import MergeFieldDropdown from '../shared/MergeFieldDropdown';

export default {

    components: {
        MergeFieldDropdown,
    },

    inject: ['$richTextBox'],

    props: {
        hasError: Boolean,
        mergeFieldCategories: Array,
        containsSupportedCharacter: Boolean,
        maxLength: Number,
        characterCountLabel: String,
        saving: Boolean,
        saved: Boolean,
    },

    data() {
        return {
            isMergeFieldDropdownOpen: false,
        };
    },

    methods: {
        insertTemplate() {
            this.$emit('insert-template');
        },

        insertMergeField(value) {
            this.isMergeFieldDropdownOpen = false;

            this.$richTextBox.insertMergeField(value);
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .footer-container {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 37.65%;

        @media($small) {
            left: 0;
            right: 0;
        }
    }

    .insert-template{
        @media($small) {
            display: none;
        }
    }

    .template-button-row {
        padding: $spacing-200;
    }

    .template-button-row {
        display: flex;
        align-items: center;
        border-top: 1px solid $color-gray-200;
    }

    .action-buttons {
        display: flex;
        flex: 1;
    }

    .saving {
        display: flex;
        align-items: center;
        color: $color-gray-700;
        --icon-size: 1rem;
        font-size: $font-size-xs;
        padding: 0 $spacing-200;

        .icon {
            animation: spin 4s infinite;
            padding: $spacing-025;
        }
    }

    .saved {
        padding: 0 $spacing-200;
    }

    .character-count {
        color: $color-text-subtle;
        align-self: end;
        margin-top: auto;
        margin-left: auto;
        font-size: px-to-rem(12px);
    }

    .footer {
        padding: 0 $spacing-200 $spacing-200;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .error {
        margin-left: $spacing-100;
        color: $color-red;
        display: inline-block;
        max-width: 60%;
        font-size: px-to-rem(14px);
    }

    .insert-template-mobile {
        display: none;

        @media($small) {
            display: flex;
        }
    }
</style>
